module.exports = __webpack_public_path__ + "static/media/storage_package.cd0212fd.jpg";